// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.border[data-v-4660d2fc] {\n  border-bottom: 1px solid #d7dae2;\n}\n", ""]);
// Exports
module.exports = exports;
